const colors = {
  common: {
    black: '#200745',
    black2: '#000000',
    light: '#F1F3FE',
    grey: '#20074566'
  },
  primary: {
    main: '#246BFD',
    light: '#D8E0F6',
    lighten: '#e3e9f8',
  },
  secondary: {
    main: '#C25FFF',
    gradientStart: '#9524DA',
    gradientEnd: '#C25FFF',
    gradientStart2: '#8010C3',
    gradientEnd2: '#B347F5',
  },
  purple: {
    main: '#A06AF9',
  },
  info: {
    main: '#94F0F0',
  },
  cyan: {
    main: '#E4E8F4',
  },
  success: {
    main: '#6AC046',
    gradientStart: '#479867',
    gradientEnd: '#70D297',
    gradientStart2: '#479867',
    gradientEnd2: '#70D297',
  },
  green: {
    main: '#46C08D',
    light: '#6bcca3',
    dark: '#318662',
    contrastText: '#fff',

  },
  error: {
    main: '#EB5757',
    second: '#FF4031',
  },
  text: {
    main: '#200745',
    primary: '#200745',
    secondary: '#858BA1',
    grey: '#5E6272',
  },
  light: {
    main: '#ffffff',
  },
  white: {
    main: '#ffffff',
  },
  dark: {
    main: '#262A34',
  },
  violet: {
    main: '#404AD0',
  },
  orange: {
    main: '#FF8669',
  },
  background: {
    default: '#F5F8FF',
    secondary: '#EFF2FD',
  },
  grey: {
    300: '#E3E7F2',
    500: '#5E6272',
    700: '#3D5181',
    1000: '#181A20',
    main: '#5E6272',
  },
  action: {
    disabledOpacity: 0.4,
  },
};

export default colors;
